const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    shop_id: {
      type: 'string',
      title: 'فروشگاه',
    },
    booth_id: {
      title: 'غرفه',
      type: 'string',
    },
    unit_fie_id: {
      type: 'string',
      title: 'واحد محصول',
    },
    co_price: {
      type: 'number',
      title: 'قیمت کارخانه',
    },
    me_price: {
      type: 'number',
      title: 'قیمت فروشگاه',
    },
    fie: {
      type: 'number',
      title: 'قیمت واحد',
    },
    stock: {
      type: 'number',
      title: 'موجودی',
    },
    max_number_buy: {
      type: 'number',
      default: 5,
      minimum: 0,
      title: 'حداکثر تعداد قابل خرید',
    },
    nonexistent_number: {
      type: 'number',
      default: 5,
      minimum: 0,
      title: 'حداقل تعداد ناموجودی',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
    details: {
      type: 'string',
      title: 'توضیحات',
    },
  },
});

export default schema;
